import React, { useState, useEffect } from 'react';
import '../pages/AdminDashboard.css';

const VistaUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  
  // Estados del modal
  const [modalAbierto, setModalAbierto] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    pin: '',
    rol: 'produccion',
    usuario: '',
    password: ''
  });

  const urlBaseAPI = 'https://api.pascolo.com.ar/api/admin/usuarios';

  const fetchUsuarios = async () => {
    setCargando(true);
    try {
      const respuesta = await fetch(urlBaseAPI);
      const data = await respuesta.json();
      if (Array.isArray(data)) setUsuarios(data);
      else setUsuarios([]);
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
      setUsuarios([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const abrirModalNuevo = () => {
    setUsuarioEditando(null);
    setFormData({ nombre: '', pin: '', rol: 'produccion', usuario: '', password: '' });
    setModalAbierto(true);
  };

  const abrirModalEditar = (user) => {
    setUsuarioEditando(user);
    setFormData({
      nombre: user.nombre,
      pin: user.pin,
      rol: user.rol,
      usuario: user.usuario || '',
      password: '' // Siempre en blanco por seguridad, si escribe algo se cambia
    });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setUsuarioEditando(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.pin.length !== 4) {
      alert("El PIN debe tener exactamente 4 caracteres.");
      return;
    }

    if (formData.rol === 'admin' && !usuarioEditando && (!formData.usuario || !formData.password)) {
      alert("Para el rol 'admin' es obligatorio ingresar un usuario y contraseña.");
      return;
    }

    const esEdicion = usuarioEditando !== null;
    const url = esEdicion ? `${urlBaseAPI}/${usuarioEditando.id}` : urlBaseAPI;
    const metodo = esEdicion ? 'PUT' : 'POST';

    try {
      const respuesta = await fetch(url, {
        method: metodo,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await respuesta.json();

      if (respuesta.ok) {
        cerrarModal();
        fetchUsuarios();
      } else {
        alert(data.error || "Hubo un error al guardar el usuario.");
      }
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  const handleEliminar = async (id, nombre) => {
    const confirmar = window.confirm(`¿Estás seguro de que querés eliminar a ${nombre}?`);
    if (!confirmar) return;

    try {
      const respuesta = await fetch(`${urlBaseAPI}/${id}`, { method: 'DELETE' });
      if (respuesta.ok) {
        fetchUsuarios();
      } else {
        const data = await respuesta.json();
        alert(data.error || "No se pudo eliminar.");
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  if (cargando) return <p>Cargando personal...</p>;

  return (
    <div className="vista-usuarios">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Personal y Accesos</h2>
        <button 
          onClick={abrirModalNuevo}
          style={{ backgroundColor: '#2d5a27', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          + Agregar Usuario
        </button>
      </div>

      <div className="tabla-container" style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '15px' }}>ID</th>
              <th style={{ padding: '15px' }}>Nombre</th>
              <th style={{ padding: '15px' }}>PIN (Fábrica)</th>
              <th style={{ padding: '15px' }}>Rol</th>
              <th style={{ padding: '15px' }}>Usuario Web</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((user) => (
              <tr key={user.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>#{user.id}</td>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>{user.nombre}</td>
                <td style={{ padding: '15px', letterSpacing: '2px' }}>{user.pin}</td>
                <td style={{ padding: '15px', textTransform: 'capitalize' }}>
                  <span style={{ 
                    padding: '4px 8px', borderRadius: '4px', fontSize: '13px', fontWeight: 'bold',
                    backgroundColor: user.rol === 'admin' ? '#cce5ff' : '#e2e3e5',
                    color: user.rol === 'admin' ? '#004085' : '#383d41'
                  }}>
                    {user.rol}
                  </span>
                </td>
                <td style={{ padding: '15px', color: '#666' }}>{user.usuario || '-'}</td>
                <td style={{ padding: '15px', textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button onClick={() => abrirModalEditar(user)} style={{ background: '#009ee3', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>Editar</button>
                  <button onClick={() => handleEliminar(user.id, user.nombre)} style={{ background: '#f44336', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>Quitar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalAbierto && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-card" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '450px', maxWidth: '90%' }}>
            <h3 style={{ marginTop: 0, borderBottom: '2px solid #2d5a27', paddingBottom: '10px' }}>
              {usuarioEditando ? 'Editar Usuario' : 'Nuevo Usuario'}
            </h3>
            
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
              
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Nombre Completo</label>
                <input type="text" name="nombre" value={formData.nombre} onChange={handleInputChange} required style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>PIN (4 dígitos)</label>
                  <input type="text" name="pin" maxLength={4} value={formData.pin} onChange={handleInputChange} required style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', letterSpacing: '2px' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Rol</label>
                  <select name="rol" value={formData.rol} onChange={handleInputChange} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}>
                    <option value="produccion">Producción</option>
                    <option value="pedidos">Pedidos</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>

              {/* RENDERIZADO CONDICIONAL: Solo aparece si elije Admin */}
              {formData.rol === 'admin' && (
                <div style={{ padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '6px' }}>
                  <p style={{ margin: '0 0 10px 0', fontSize: '13px', color: '#666' }}>Credenciales para acceder al Panel Web</p>
                  
                  <div style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'block', fontWeight: 'bold', fontSize: '13px', marginBottom: '4px' }}>Usuario Web</label>
                    <input type="text" name="usuario" value={formData.usuario} onChange={handleInputChange} required={formData.rol === 'admin'} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                  </div>

                  <div>
                    <label style={{ display: 'block', fontWeight: 'bold', fontSize: '13px', marginBottom: '4px' }}>Contraseña</label>
                    <input type="password" name="password" placeholder={usuarioEditando ? "Dejar en blanco para mantener actual" : ""} value={formData.password} onChange={handleInputChange} required={formData.rol === 'admin' && !usuarioEditando} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button type="submit" style={{ flex: 1, padding: '12px', backgroundColor: '#2d5a27', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Guardar</button>
                <button type="button" onClick={cerrarModal} style={{ flex: 1, padding: '12px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Cancelar</button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VistaUsuarios;